/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateUserRequest } from "../models/CreateUserRequest";
import type { InvitationStatus } from "../models/InvitationStatus";
import type { InviteUsersRequest } from "../models/InviteUsersRequest";
import type { RoleDTO } from "../models/RoleDTO";
import type { UpdateUserRequest } from "../models/UpdateUserRequest";
import type { UpdateUserRoleRequest } from "../models/UpdateUserRoleRequest";
import type { UserColumnValuesRequestDTO } from "../models/UserColumnValuesRequestDTO";
import type { UserDTO } from "../models/UserDTO";
import type { UserExistingRolesRequestDTO } from "../models/UserExistingRolesRequestDTO";
import type { UserExistingRolesResponseDTO } from "../models/UserExistingRolesResponseDTO";
import type { UserInformationDTO } from "../models/UserInformationDTO";
import type { UserRequestDTO } from "../models/UserRequestDTO";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class UsersService {
  /**
   * @returns UserDTO
   * @throws ApiError
   */
  public static usersGet(): CancelablePromise<Array<UserDTO>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Users",
    });
  }

  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static usersPost(
    requestBody: Array<CreateUserRequest>
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param requestBody
   * @returns UserDTO
   * @throws ApiError
   */
  public static usersGetUsersPaged(
    requestBody: UserRequestDTO
  ): CancelablePromise<Array<UserDTO>> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/GetUsersPaged",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param requestBody
   * @returns string
   * @throws ApiError
   */
  public static usersGetColumnFilterValues(
    requestBody: UserColumnValuesRequestDTO
  ): CancelablePromise<Array<string>> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/GetColumnFilterValues",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param requestBody
   * @returns UserExistingRolesResponseDTO
   * @throws ApiError
   */
  public static usersGetExistingRolesCount(
    requestBody: UserExistingRolesRequestDTO
  ): CancelablePromise<UserExistingRolesResponseDTO> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/GetExistingRolesCount",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns number
   * @throws ApiError
   */
  public static usersGetTotalUsers(): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Users/GetTotalUsers",
    });
  }

  /**
   * @returns UserDTO
   * @throws ApiError
   */
  public static usersGetInvitableUsers(): CancelablePromise<Array<UserDTO>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Users/GetInvitableUsers",
    });
  }

  /**
   * @param id
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static usersUpdate(
    id: number,
    requestBody: UpdateUserRequest
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/update/{id}",
      path: {
        id: id,
      },
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static usersRemoveRole(
    requestBody: UpdateUserRoleRequest
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/removeRole",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param requestBody
   * @returns void
   * @throws ApiError
   */
  public static usersAddRole(
    requestBody: UpdateUserRoleRequest
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/addRole",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns RoleDTO
   * @throws ApiError
   */
  public static usersGetAllRoles(): CancelablePromise<Array<RoleDTO>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Users/GetAllRoles",
    });
  }

  /**
   * @param requestBody
   * @returns number
   * @throws ApiError
   */
  public static usersInviteUsersWithRoles(
    requestBody: InviteUsersRequest
  ): CancelablePromise<Array<number>> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/InviteUsersWithRoles",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param requestBody
   * @returns InvitationStatus
   * @throws ApiError
   */
  public static usersGetInvitationStatuses(
    requestBody: Array<number>
  ): CancelablePromise<Array<InvitationStatus>> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/GetInvitationStatuses",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param instanceId
   * @returns any
   * @throws ApiError
   */
  public static usersGetBackgroundProcessStatus(
    instanceId: string | null
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Users/BackgroundProcessStatus/{instanceId}",
      path: {
        instanceId: instanceId,
      },
    });
  }

  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static usersUserExists(requestBody: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/UserExists",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public static usersLastLoggedIn(requestBody: string): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/LastLoggedIn",
      body: requestBody,
      mediaType: "application/json",
    });
  }

  /**
   * @returns any
   * @throws ApiError
   */
  public static usersGetTotalAssignedUsers(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Users/GetTotalAssignedUsers",
    });
  }

  /**
   * @param azureIdentityId
   * @param unrestrictedAccess
   * @returns RoleDTO
   * @throws ApiError
   */
  public static usersGetUserRoles(
    azureIdentityId?: string | null,
    unrestrictedAccess?: boolean
  ): CancelablePromise<Array<RoleDTO>> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Users/GetUserRoles",
      query: {
        azureIdentityId: azureIdentityId,
        unrestrictedAccess: unrestrictedAccess,
      },
    });
  }

  /**
   * @param azureIdentityId
   * @returns UserInformationDTO
   * @throws ApiError
   */
  public static usersGetUserInformation(
    azureIdentityId?: string | null
  ): CancelablePromise<UserInformationDTO> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/api/Users/GetUserInformation",
      query: {
        azureIdentityId: azureIdentityId,
      },
    });
  }

  /**
   * @param userEmail
   * @returns void
   * @throws ApiError
   */
  public static usersAddAccountOwner(
    userEmail?: string | null
  ): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/Users/AddAccountOwner",
      query: {
        userEmail: userEmail,
      },
    });
  }
}
